import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { observabilityApi, type OperationsDashboard } from '../../api/observability';

export function PerformanceDashboardPage() {
  const [dashboard, setDashboard] = useState<OperationsDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void observabilityApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/observability" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Operations Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Performance Dashboard</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {dashboard && (
        <div className="mt-4 grid gap-4 sm:grid-cols-2">
          <div className="rounded-xl border p-4 dark:border-slate-700">
            <p className="text-sm text-slate-500">SLO Compliance</p>
            <p className="text-3xl font-semibold">{dashboard.slo_compliance_pct.toFixed(1)}%</p>
          </div>
          <div className="rounded-xl border p-4 dark:border-slate-700">
            <p className="text-sm text-slate-500">Error Budget Used</p>
            <p className="text-3xl font-semibold">{dashboard.error_budget_used_pct.toFixed(1)}%</p>
          </div>
          <div className="rounded-xl border p-4 dark:border-slate-700">
            <p className="text-sm text-slate-500">Total Traces</p>
            <p className="text-3xl font-semibold">{dashboard.total_traces}</p>
          </div>
          <div className="rounded-xl border p-4 dark:border-slate-700">
            <p className="text-sm text-slate-500">OpenTelemetry</p>
            <p className="text-lg font-semibold">{dashboard.otel_status.enabled ? 'Active' : 'Disabled'}</p>
            <p className="text-xs text-slate-500">{dashboard.otel_status.exporters.length} exporters · sample {dashboard.otel_status.sample_rate * 100}%</p>
          </div>
        </div>
      )}
    </div>
  );
}
